module.exports = ":host ::ng-deep .card-container {\n  min-width: 100%; }\n"